import { capitalize } from './capitalize'
import langs from './language.json'

// -------------------------------------------
// Standard replacer for sentences with drugs
// Make bold and keep capitalization of match
// -------------------------------------------
export function replaceDrugs( place1, place2, lang = "" ) {

  // a regexp for cyrillic characters
  const cyril = new RegExp( "[\u0400-\u04FF]+" )

  // Negative look behind (?<!>)
  // Negative look ahead (?!<)

  const drug1s = new RegExp( `([\s^=]?)${place1}[\u0400-\u04FF]*(?!<)`, "g" )
  const drug1c = new RegExp( `([\s^=]?)${capitalize(place1)}[\u0400-\u04FF]*(?!<)`, "g" )
  const drug2s = new RegExp( `([\s^=]?)${place2}[\u0400-\u04FF]*(?!<)`, "g" )
  const drug2c = new RegExp( `([\s^=]?)${capitalize(place2)}[\u0400-\u04FF]*(?!<)`, "g" )
  const drug2i = new RegExp( `([\s^=]?)${place2}[\u0400-\u04FF]*(?!<)`, "gi" )

  const dict = langs[ lang ]

  // ----------------------------------------------------------
  // Input Parameters
  // List - name of substances
  // Single - Only simvastatine is great
  // Plural - Only simvastatine and clarithromycine are great
  // None - No drugs have been selected
  // ----------------------------------------------------------
  return ( list = [], single = "", plural = "", none = "" ) => {

    // Find the ending for the russian language
    var ending = ""
    if ( lang === "ru" ) {
      var match = null
      match = single.match( drug1s )
      if ( !match ) {
        match = single.match( drug1c )
      }
      if ( match ) {
        ending = match[ 0 ].toLowerCase().replace( place1, "" )
      }
    }

    // Enforce array
    list = Array.isArray( list ) ? list : [ list ]
    // Avoid undefined in array
    list = list.slice( 0 ).filter( drug => !!drug )

    // Add the corresponding ending at the end of the drug names for russian
    if ( lang === "ru" ) {
      list = list.map( el => el.replace( el.match( cyril )[ 0 ], el.match( cyril )[ 0 ] + ending ) )
    }

    // Caller was too lazy to check
    if ( list.length == 0 ) return none

    // Replace 1. placeholder case sensitive
    if ( list.length == 1 ) {
      // Allow custom styles
      single = list[ 0 ].includes( ">" ) ?
        single.replace( drug1s, list[ 0 ] ) :
        single.replace( drug1s, `<b class=d>${list[ 0 ]}</b>` )
      // Small written drugs at start of sentence
      return single.replace( drug1c, `<b class=d>${capitalize( list[ 0 ] )}</b>` )
    }

    // Mulitple Drugs
    if ( list.length > 1 ) {
      const last = list.pop()
      // Allow custom styles
      const pres = list.map( name => {
        if ( name.includes( ">" ) ) return name
        if ( !name.includes( ">" ) ) return `<b class=d>${name}</b>`
      } ).join( dict.comma )
      // Small written drugs at start of sentence
      const prec = list.map( ( name, idx ) => {
        if ( idx == 0 ) return `<b class=d>${capitalize(name)}</b>`
        if ( idx > 0 ) return `<b class=d>${name}</b>`
      } ).join( dict.comma )
      // Replace
      plural = plural || single
      plural = plural.replace( drug1s, pres )
      // Small written drugs at start of sentence
      plural = plural.replace( drug1c, prec )
      // Always replace last drug as from drug.name and allow custom styles
      return last.includes( ">" ) ?
        plural.replace( drug2i, last ) :
        plural.replace( drug2i, `<b class=d>${last}</b>` )
    }
  }

}
